import Slider from "./components/Slider";

if($('.carousel-hero').length) {
    let carouselDom = document.querySelector('.carousel');
    let SliderDom = carouselDom.querySelector('.carousel .list');
    let thumbnailBorderDom = document.querySelector('.carousel .thumbnail');
    let thumbnailItemsDom = thumbnailBorderDom && thumbnailBorderDom.querySelectorAll('.item');
    
    //thumbnailItemsDom && thumbnailBorderDom.appendChild(thumbnailItemsDom[0]);
    let timeRunning = 600;
    let runTimeOut;
    
    const $thumbnailWrapSlider = $('#thumbnail-wrap-slider');
    if($thumbnailWrapSlider.length) {
        $thumbnailWrapSlider._instance = new Slider('#thumbnail-wrap-slider', {
            rubberband: false,
            loop: true,
            arrows: true,
            pager: true,
            slides: {
                perView: 5,
                spacing: 16,
            },
            breakpoints: {
                '(max-width: 767px)': {
                    origin: 'center',
                    drag: true,
                    loop: true,
                    arrows: true,
                    slides: {
                        origin: 'center',
                        perView: 1.2,
                        spacing: 8,
                    },
                },
            },
            animationEnded: () => {
                const instance = $thumbnailWrapSlider._instance.instance;
                let direction = instance.direction || 'next';
                let SliderItemsDom = SliderDom.querySelectorAll('.carousel .list .item');
                
                if(direction === 'index') {
    
                    const itemId = $('.carousel .thumbnail .item[data-index="' + instance.track.details.rel + '"]').attr('data-itemId');
                    const $listItem = $('.carousel .list .item[data-itemId="' + itemId + '"]');
                    
                    SliderDom.appendChild(SliderItemsDom[0]);
                    SliderDom.prepend($listItem[0]);
    
                    carouselDom.classList.add('next');
    
                } else if(direction === 'prev') {
                    const itemId = $('.carousel .thumbnail .item[data-index="' + instance.track.details.rel + '"]').attr('data-itemId');
                    const $listItem = $('.carousel .list .item[data-itemId="' + itemId + '"]');

                    carouselDom.classList.add(direction);
                    SliderDom.prepend($listItem[0]);
                } else {
                    const itemId = $('.carousel .thumbnail .item[data-index="' + instance.track.details.rel + '"]').attr('data-itemId');
                    const $listItem = $('.carousel .list .item[data-itemId="' + itemId + '"]');

                    carouselDom.classList.add(direction);
                    SliderDom.appendChild(SliderItemsDom[0]);
                    SliderDom.prepend($listItem[0]);
                }
    
                clearTimeout(runTimeOut);
                runTimeOut = setTimeout(() => {
                    carouselDom.classList.remove('next');
                    carouselDom.classList.remove('prev');
                }, timeRunning);
            },
        });
    }

    $('.thumbnail .item').on('click', e => {
        const $target = $(e.currentTarget);
        const index = +$target.attr('data-index');
        
        $thumbnailWrapSlider._instance.instance.direction = 'index';
        $thumbnailWrapSlider._instance.instance.moveToIdx(index);
    });
    
    /*document.getElementById("body").onscroll = function myFunction() {  
        var scrolltotop = document.scrollingElement.scrollTop;
    
        var xvalue = "center";
        var factor = 0.5;
        var yvalue = scrolltotop * factor;
    
        Array.from(document.getElementsByClassName("parllax")).forEach(function(item) {
            item.style.objectPosition = xvalue + " " + yvalue + "px";
        });
        
    }*/
}